import React from 'react';
import NavigationModel from '../../../components/CustomNavigation/NavigationModel';

const ClassRoomEvaluationNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const cred = localStorage.getItem('cred');
  const userId = cred ? JSON.parse(cred)?.profile?.userId : null;
  const  redirectUrl = `${phpNavigationUrl}/evaluation/classroom_evaluation_cro/${userId}/2`;

  return <NavigationModel redirectUrl={redirectUrl} title="Classroom Evaluations - CRO" navigationTo={'Old Portal'} />;
};

export default ClassRoomEvaluationNavigation;
